import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

// components
import { ItemStatusTag } from "shared/components/customers/boxes/common/item-figure/item-status-tag";

// helper
import * as helper from './helper';

const SIZES = [
    "XS/34",
    "S/36",
    "M/38/40",
    "L/42",
    "XL/44",
    "XXL/46",
    "XXXL/48",
    "ONESIZE"
];

const SizeColumn = ({ size, data }) => {
    if (!!data[size] && data[size].length === 0) {
        return null;
    };

    return (
        <div className="columns">
            <div className="column is-2">
                <p className="subtitle is-4">{data[size] && size}</p>
            </div>
            <div className="column">
                <div className="columns is-multiline">
                    {data[size] && data[size].map(product => (
                        <ProductCard product={product} />
                    ))}
                </div>
            </div >
        </div >
    )
}

const ProductCard = ({ product }) => {
    if (!product) {
        return null;
    };

    const icon = product.market === "Sweden" ? '/sweden.svg' : '/france.svg';

    return (
        <div className="column is-3">
            <div className="card">
                <div className="columns m-2">
                    <div className="column is-2">
                        <img className="image is-16x16" src={icon} alt={product.market} />
                    </div>
                    <div className="column">
                        <ItemStatusTag item={product} />
                    </div>
                    <div className="column is-4">
                        <p>{product.location}</p>
                    </div>
                </div>
                <div className="card-content">
                    <div className="content">
                        <p className="title is-4">
                            <Link target="_blank" to={`/products/${product.barcode}`}>{product.barcode}</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div >
    );
}

const ProductsByModel = () => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const { id } = useParams();

    useEffect(() => {
        const getProductsByModel = async () => {
            const products = {};
            const results = await helper.getProductsBySKU(id);
            setLoading(false);
            for (const size of SIZES) {
                const filteredProducts = results.filter(r => r.size === size);
                products[size] = filteredProducts;
            };
            setData(products);
        };

        if (!!data) {
            getProductsByModel();
        };
    }, [id, data]);

    return (
        <div className="container has-text-centered mt-4 py-4">
            <div className="columns">
                <div className="column">
                    <p className="title is-size-2 centered">
                        Products linked to the model: {id}
                    </p>
                </div>
            </div>
            {loading && (
                <div className="container mt-6">
                    <progress className="progress is-large is-primary" max="100">60%</progress>
                </div>
            )}
            {!loading && !data &&
                <>
                    <div className="icon-text">
                        <span className="icon is-strong has-text-danger">
                            <i className="fas fa-ban"></i>
                        </span>
                        <span className="title is-4">No Results</span>
                    </div>

                    <p className="block">
                        There is no products linked to this model yet.
                    </p>
                </>
            }
            {!loading && !!data &&
                SIZES.map(size =>
                    <SizeColumn size={size} data={data} />
                )
            }
        </div>
    )
}


export { ProductsByModel };
